import usePrivateAxios from "@/common/api/usePrivateAxios"
import { MaintenanceSpecificationValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { useMutation } from "@tanstack/react-query"

interface UseCreateEstablishmentLeadMaintenanceSpecificationProps {
  establishmentLeadId: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useCreateEstablishmentLeadMaintenanceSpecification = ({
  establishmentLeadId,
  onSuccess,
  onError,
}: UseCreateEstablishmentLeadMaintenanceSpecificationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createEstablishmentLeadMaintenanceSpecification'],
    mutationFn: (data: MaintenanceSpecificationValidationSchema) => {
      const payload = {
        maintenance_specifications_attributes: [
          {
            directive_klass: data.directive_klass,
            equipment_category_specifications_attributes: data.equipment_category_specifications_attributes?.map(
              ({ value }) => ({
                category_id: value,
              })
            ),
            equipment_manufacturer_specifications_attributes: data.equipment_manufacturer_specifications_attributes?.map(
              ({ value }) => ({
                manufacturer_id: value,
              })
            ),
            system_specifications_attributes: data.system_specifications_attributes?.map(
              ({ value }) => ({
                system_id: value,
              })
            ),
          },
        ],
      }

      return privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}/update_maintenance_models`, {
        lead: payload,
      });
    },
    onSuccess,
    onError,
  })
}
